import styleFn, {compose} from '../util'
const width = styleFn({propName: 'width'})
const height = styleFn({propName: 'height'})
const maxHeight = styleFn({propName: 'maxHeight'})
const maxWeight = styleFn({propName: 'maxWeight'})
export default compose(
  width,
  height,
  maxHeight,
  maxWeight
)
